<template>
  <Form :ref="'form' + current" :model="form" :rules="rules" :label-width="165">
    <Divider orientation="left">申请人基本信息</Divider>

    <Row :gutter="16">
      <!-- <Col span="24">
      <FormItem label="业务类别" prop="ywlb">
        <Select v-model.trim="form.ywlb" placeholder="积分新办：年龄+教育背景（高于或等于本科学士）+社保年限" style="width:100%">
          <Option v-for="select in ywlbList" :value="select.value" :key="select.value">{{ select.name }}</Option>
        </Select>
      </FormItem>
      </Col> -->

      <Col span="12">
      <FormItem label="上传申请人身份证人像面" prop="applicantIDCardFrontGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <div>
              <Upload type="drag" class="uploadImage" :max-size="5120" :on-exceeded-size="handleMaxSize" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantIDCardFrontGuidProgress')"
                :show-upload-list="false" :accept="accept" :format="format" :data="uploadData" :on-success="
                    (response, file, fileList) =>
                     {$refs['applicantIDCardFrontGuidProgress'].updateShow(false)
        $refs['applicantIDCardFrontGuidProgressUpload'].style.display = 'block'; handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantIDCardFrontGuid',false,'idCard',[{name:'applicantName'},{idCard:'applicantIDCardNo'}]
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantIDCardFrontGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardFrontGuid',false,'idCard',[{name:'applicantName'},{idCard:'applicantIDCardNo'}])">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantIDCardFrontGuidProgress"></progress-bar>
                </div>
              </Upload>

            </div>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantIDCardFrontGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL +
                        '/file/cover/' +
                        form.applicantIDCardFrontGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardFrontGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantIDCardFrontGuid,
                            'applicantIDCardFrontGuid'
                          )
                        " type="ios-trash-outline" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="上传申请人身份证国徽面" prop="applicantIDCardBackGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" ref="applicantIDCardBackGuid" :data="{readIdbackAfterUploaded: true}" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantIDCardBackGuidProgress')"
              class="uploadImage" :accept="accept" :format="format" :show-upload-list="false" :on-success="
                    (response, file, fileList) =>
                     {$refs['applicantIDCardBackGuidProgress'].updateShow(false)
        $refs['applicantIDCardBackGuidProgressUpload'].style.display = 'block'; handleSuccess(
                        response,
                        file,
                        fileList,
                        'applicantIDCardBackGuid',false,'idcard_back'
                      )}
                  " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="applicantIDCardBackGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('applicantIDCardBackGuid',false,'idcard_back')">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="applicantIDCardBackGuidProgress"></progress-bar>
              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantIDCardBackGuid">
              <span class="pos">
                <img class="img uploadImage" :src="
                        $baseURL + '/file/cover/' + form.applicantIDCardBackGuid
                      " />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantIDCardBackGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="
                          handleRemove(
                            0,
                            form.applicantIDCardBackGuid,
                            'applicantIDCardBackGuid'
                          )
                        " type="ios-trash-outline" />
                </i>
              </span>
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="申请人姓名" prop="applicantName">
        <Input v-model.trim="form.applicantName" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label="申请人身份证号" prop="applicantIDCardNo">
        <Input v-model.trim="form.applicantIDCardNo" disabled :maxlength="20" placeholder="上传身份证人像面自动识别"></Input>
      </FormItem>
      </Col>
      <Col span="24">
      <FormItem label="申请人联系方式" prop="applicantPhone">
        <Input v-model.trim="form.applicantPhone" :maxlength="40" placeholder="请填写"></Input>
      </FormItem>
      </Col>
    </Row>
    <div class="bom_btn">
      <div>
        <Button @click="next(null,  -1)">上一步</Button>
        <Button type="primary" @click="next('form' + current, 1)">下一步</Button>
      </div>
    </div>
  </Form>
</template>
<script>
export default {
  props: {
    form: { type: Object },
    current: { type: Number },
    hasLaborDispatchPermit: { type: Boolean },
  },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: { readIdInfo: true },
      //   ywlbList: [
      //     {
      //       name: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
      //       value: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
      //     },
      //   ],
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,

      rules: {
        personnelPhone: [{ required: true, message: '请输入', trigger: 'change' }],
        applicantIDCardFrontGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        applicantIDCardBackGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        applicantName: [{ required: true, message: '请输入', trigger: 'change' }],
        applicantIDCardNo: [
          { required: true, message: '请输入', trigger: 'change' },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '请输入正确的身份证号',
            trigger: 'blur',
          },
        ],
        applicantPhone: [
          { required: true, message: '请输入', trigger: 'change' },
          {
            pattern: /^[0-9]+$/,
            message: '请输入正确的联系方式',
            trigger: 'change',
          },
        ],
        applicantResidencePermitFrontGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        dispatchAgreementGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        applicantTaxPaymentCertificateGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        laborContractGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        hasLaborDispatchPermit: [
          { required: true, message: '请选择', type: 'boolean', trigger: 'change' },
        ],
        acceptanceCenter: [{ required: true, message: '请选择', trigger: 'change' }],
        hasEducation: [{ required: true, message: '请选择', type: 'boolean', trigger: 'change' }],
        jobAgreementGuidList: [
          { required: true, message: '请上传', trigger: 'change', type: 'array' },
        ],
        applicantResidencePermitBackGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantRegisteredResidenceType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        applicantCollectiveAccountMaterialsType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        applicantPoliceStationRegistrationCertificateGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
        applicantResidencePermitExpiryDate: [
          {
            required: true,
            message: '请选择',
            type: 'date',
            trigger: 'change',
          },
        ],
        hasPersonFiles: [
          {
            required: true,
            message: '请选择',
            type: 'boolean',
            trigger: 'change',
          },
        ],
        isSpouseRegisteredResidenceInSH: [
          {
            required: true,
            message: '请选择',
            type: 'boolean',
            trigger: 'change',
          },
        ],
        declarationItems: [{ required: true, message: '请输入', trigger: 'change' }],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //   this.$Message.success('Success!')
      let _this = this
      let submiteUrl = `/api/services/app/JZZJFApi/SaveAppApplicantInfo`

      if (name === null) {
        this.$emit('next', val, submiteUrl)
        return
      }

      this.$refs[name].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }

        _this.$emit('next', val, submiteUrl)
      })
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件大小超出
    handleMaxSize(file) {
      this.$emit('handleMaxSize', file)
    },
    //上传前 用于单个上传清空上传列表
    handleBefore(property) {
      //不为数组时传一个删一个列表
      this.$refs[property].clearFiles()
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //时间格式化
    changeDateFmt(dateFmt, date, property) {
      this.$emit('changeDateFmt', dateFmt, date, property)
    },
    //户籍改变
    isSpouseRegisteredResidenceInSHChange(e) {},
    ////档案改变
    isArchiveInCurrentEnterpriseChange(e) {
      console.log('🚀 ~ isArchiveInCurrentEnterpriseChange ~ e:', e)
      if (e) {
        this.form.applicantArchivesCustodyInstitution = this.form.enterpriseName
      } else {
        this.form.applicantArchivesCustodyInstitution = ''
      }
    },
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      this.$refs[name + 'Upload'].style.display = 'none'
      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
  },
}
</script>